module.exports = __webpack_public_path__ + "img/app-xvan.d960ae71.png";